module.exports = {"data":{"site":{"siteMetadata":{"title":"Mono2Ski","author":"Lawrence Gosset"}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/about.json
// module id = 485
// module chunks = 273950069227526